import { PoGameInternal } from './game/PoGameInternal';

declare global {
  interface Window {
    ReactNativeWebView: any;
    _po_gm: PoGameInternal;
    po_gm: PoGame;
    model: any;
    game: any;
  }
}

class PoGame {
  private internal: PoGameInternal;

  constructor(internal: PoGameInternal) {
    this.internal = internal;
  }

  public start = config => {
    if (this.setConfig(config)) {
      this.internal.start();
      window.game.scene.keys.PreloadingScene.scene.start('WelcomeScene');
    }
  };

  public setConfig = config => {
    if (!this.checkConfig(config)) return false;
    this.internal.setConfig(config);
    return true;
  };

  private checkConfig = config => {
    const errors: string[] = [];
    //in case we are re-running with a different config or received a new config
    //we need to clean up past error scene
    window.game.scene.keys.ErrorScene.scene.stop();

    if (!config) {
      errors.push('Config cannot be empty');
    }
    if (!config.gameId) {
      errors.push('Config gameId field cannot be empty');
    }
    if (!config.drawId) {
      errors.push('Config drawId field cannot be empty');
    }
    if (!config.winningNumber) {
      errors.push('Config winningNumber field cannot be empty');
    }

    if (!!config.winningNumber && (config.winningNumber > 15 || config.winningNumber < 1)) {
      errors.push('Config winningNumber must be between 1 and 15 inclusive');
    }

    if (!config.winningPrize) {
      errors.push('Config winningPrize field cannot be empty');
    }

    if (!!config.winningPrize && [20, 50, 100, 250, 5, 7, 10].indexOf(config.winningPrize) === -1) {
      errors.push('Config winningPrize can on be in [20, 50, 100, 250, 5, 7, 10]');
    }

    if (errors.length > 0) {
      this.internal.setConfig({ errorMsg: errors });
      window.game.scene.keys.PreloadingScene.scene.start('ErrorScene');
      return false;
    }

    return true;
  };

  public onGameEndHandler = method => {
    this.internal.registerHandler('onGameEndHandler', method);
  };

  public onGameErrorHandler = method => {
    this.internal.registerHandler('onGameErrorHandler', method);
  };

  public onGameReplayHandler = method => {
    this.internal.registerHandler('onGameReplayHandler', method);
  };

  public onGameExitHandler = method => {
    this.internal.registerHandler('onGameExitHandler', method);
  };

  public onGamePauseHandler = method => {
    this.internal.registerHandler('onGamePauseHandler', method);
  };

  public onGameReadyHandler = method => {
    this.internal.registerHandler('onGameReadyHandler', method);
  };

  public onGameResumeHandler = method => {
    this.internal.registerHandler('onGameResumeHandler', method);
  };

  public onGameResultHandler = method => {
    this.internal.registerHandler('onGameResultHandler', method);
  };

  public onGameStartHandler = method => {
    this.internal.registerHandler('onGameStartHandler', method);
  };

  public onEnterTicketHandler = method => {
    this.internal.registerHandler('onEnterTicketHandler', method);
  };

  public onPreviousGameHandler = method => {
    this.internal.registerHandler('onPreviousGameHandler', method);
  };

  public onNextGameHandler = method => {
    this.internal.registerHandler('onNextGameHandler', method);
  };

  public onLatestGameHandler = method => {
    this.internal.registerHandler('onLatestGameHandler', method);
  };

  public updateAutoPlayHandler = method => {
    this.internal.registerHandler('updateAutoPlayHandler', method);
  };
}

// handler
window._po_gm = new PoGameInternal();
window.po_gm = new PoGame(window._po_gm);
window.onerror = function(msg, error) {
  const errorObj = {
    message: msg,
    details: error,
    stacktrace: null
  };
  window._po_gm.error(errorObj);
  return false;
};

/* */
function resume() {
  window._po_gm.resume();
}

function pause() {
  window._po_gm.pause();
}

window.addEventListener('focus', resume);
window.addEventListener('blur', pause);

/* game listener function */
function sendPostMsg(name, data) {
  if (window.hasOwnProperty('ReactNativeWebView')) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: 'pomaFunctionInvocation',
        name,
        data
      })
    );
  } else {
    window.parent.postMessage(
      JSON.stringify({
        type: 'poGame',
        name,
        data
      }),
      '*'
    );
  }
}

function onGameErrorNotifier(errorObject) {
  console.log('Error received : ', errorObject);
  sendPostMsg('onGameErrorHandler', errorObject);
}

function onGameStartNotifier() {
  console.log('onGameStartHandler called.');
  sendPostMsg('onGameStartHandler', null);
}

function onGameEndNotifier(data) {
  console.log('onGameEndHandler called.');
  sendPostMsg('onGameEndHandler', data);
}

function onGameReplayNotifier() {
  console.log('onGameReplayNotifier called.');
  sendPostMsg('onGameReplayHandler', null);
}

function onGameExitNotifier() {
  console.log('onGameExitNotifier called.');
  sendPostMsg('onGameExitHandler', null);
}

function onGameReadyNotifier() {
  console.log('onGameReadyNotifier called.');
  sendPostMsg('onGameReadyHandler', null);
}

function onGameResumeNotifier() {
  console.log('onGameResumeNotifier called.');
  sendPostMsg('onGameResumeHandler', null);
}

function onGamePausedNotifier() {
  console.log('onGamePausedNotifier called.');
  sendPostMsg('onGamePauseHandler', null);
}

function onGameResultNotifier(obj) {
  console.log('onGameResultNotifier', obj);
  sendPostMsg('onGameResultHandler', obj);
}

function onEnterTicketNotifier(obj) {
  console.log('onEnterTicketNotifier', obj);
  sendPostMsg('onEnterTicketHandler', obj);
}

function onPreviousGameNotifier() {
  console.log('onPreviousGameNotifier called.');
  sendPostMsg('onPreviousGameHandler', null);
}

function onNextGameNotifier() {
  console.log('onNextGameNotifier called.');
  sendPostMsg('onNextGameHandler', null);
}

function onLatestGameNotifier() {
  console.log('onLatestGameNotifier called.');
  sendPostMsg('onLatestGameHandler', null);
}

function updateAutoPlayNotifier(data) {
  console.log('updateAutoPlayNotifier called.', data);
  sendPostMsg('updateAutoPlayHandler', data);
}

function receiveMessage(event) {
  try {
    const message = JSON.parse(event.data);
    if (!message || message.type !== 'poGameParent') return;
    switch (message.name) {
      case 'setGameConfig': {
        if (message.data) {
          window.po_gm.start(message.data);
          console.log('start the game');
        }
        break;
      }
      default:
        break;
    }
  } catch {}
}

if (window.hasOwnProperty('ReactNativeWebView')) {
  if (
    window.navigator.platform.toLowerCase() === 'iphone' ||
    window.navigator.userAgent.toLowerCase() === 'iphone' ||
    window.navigator.platform.toLowerCase() === 'ipad' ||
    window.navigator.userAgent.toLowerCase() === 'ipad' ||
    (window.navigator.platform.toLowerCase() === 'macintel' && window.navigator.maxTouchPoints > 1) ||
    window.navigator.userAgent.toLowerCase() === 'macintel'
  ) {
    window.addEventListener('message', receiveMessage);
  } else {
    document.addEventListener('message', receiveMessage);
  }
} else {
  window.addEventListener('message', receiveMessage, false);
}

/* Game Listener */
window.po_gm.onGamePauseHandler(onGamePausedNotifier);
window.po_gm.onGameResumeHandler(onGameResumeNotifier);
window.po_gm.onGameResultHandler(onGameResultNotifier);
window.po_gm.onGameStartHandler(onGameStartNotifier);
window.po_gm.onGameReadyHandler(onGameReadyNotifier);
window.po_gm.onGameEndHandler(onGameEndNotifier);
window.po_gm.onGameReplayHandler(onGameReplayNotifier);
window.po_gm.onGameExitHandler(onGameExitNotifier);
window.po_gm.onGameErrorHandler(onGameErrorNotifier);
window.po_gm.onEnterTicketHandler(onEnterTicketNotifier);
window.po_gm.onPreviousGameHandler(onPreviousGameNotifier);
window.po_gm.onNextGameHandler(onNextGameNotifier);
window.po_gm.updateAutoPlayHandler(updateAutoPlayNotifier);
window.po_gm.onLatestGameHandler(onLatestGameNotifier);
